import React from "react";
import ReactSelect from "../../../../common/ReactSelect/ReactSelect";

const RenderUnits = ({ units, unit_type_id, onChange, defaultValue }) => {
  const partUnits =
    units
      .find((u) => u.unit_type_id === unit_type_id)
      ?.unit_type_for_name?.map((a) => ({
        value: a.unit_id,
        label: a.unit_name,
      })) || [];

  return (
    <ReactSelect
      options={partUnits}
      cutomeHeight="34px"
      onChange={onChange}
      defaultValue={defaultValue}
    />
  );
};

export default RenderUnits;
